<div class="titleBlock">
  <h4 class="text-center">Welcome! Let’s Get You Started 🚀</h4>
  <p>
    Complete your profile, connect your social media accounts, and unlock powerful tools to create,
    schedule, and grow your brand effortlessly.
  </p>
</div>
<div class="videoBlock">
  <div class="videoWrap">
    <iframe
      width="560"
      height="315"
      src="https://www.youtube-nocookie.com/embed/gJ8WFaVCmuA?si=IcwfJpUHxaGwU5YH&amp;controls=0"
      title="YouTube video player"
      frameborder="0"
      allow="
        accelerometer;
        autoplay;
        clipboard-write;
        encrypted-media;
        gyroscope;
        picture-in-picture;
        web-share;
      "
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  </div>
</div>
<div class="boardWrap">
  <p-button
    (click)="submit()"
    styleClass="blueBtn"
    label="Continue"
    icon="pi pi-arrow-right"
    iconPos="right"
  ></p-button>
</div>
